import { createContext, useContext, useEffect, useState } from "react";
import { tierPrice } from "../lib/api";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dg_cart")) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("dg_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.sku === product.sku);
      if (existing) return prev.map((i) => (i.sku === product.sku ? { ...i, qty: i.qty + qty } : i));
      return [...prev, {
        sku: product.sku, slug: product.slug, name: product.name, brand: product.brand,
        image: product.image, volume: product.volume, price_tiers: product.price_tiers, qty,
      }];
    });
  };

  const updateQty = (sku, qty) => {
    if (qty <= 0) return removeItem(sku);
    setItems((prev) => prev.map((i) => (i.sku === sku ? { ...i, qty } : i)));
  };

  const removeItem = (sku) => setItems((prev) => prev.filter((i) => i.sku !== sku));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + tierPrice(i.price_tiers, i.qty) * i.qty, 0);
  const vat = subtotal * 0.21;

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal, vat, total: subtotal + vat }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
